import {
  Modal as AntdModal,
  ConfigProvider,
  ModalFuncProps,
  ModalProps,
} from "antd";
import { PropsWithChildren } from "react";
import CloseIcon from "../../assets/svg/CloseIcon";
import NormalTipIcon from "../../assets/svg/NormalTipIcon";
import { ModalStyle, TipWrapper } from "./atom";
import i18next from "i18next";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
export type RenderbusModalProps = PropsWithChildren<
  ModalProps & {
    type?: string;
    size?: "small" | "normal" | "large";
    tipContent?: string;
  }
>;

const SizeMap = {
  small: 420,
  normal: 560,
  large: 720,
};

export function Modal({
  type,
  children,
  okButtonProps,
  cancelButtonProps,
  width,
  size = "normal",
  className,
  tipContent = "",
  ...props
}: RenderbusModalProps) {
  const finalWidth = type === "text" ? "small" : size;
  const sizeWidth = SizeMap[finalWidth];
  return (
    <ConfigProvider
      locale={i18next.language === "zh" ? zhCN : enUS}
      theme={{
        token: {
          colorText: "#FFFFFF",
        },
      }}
    >
      <AntdModal
        className={`renderbus-ui--modal ${className} ${
          type === "text" ? "pure-text-modal" : ""
        }`}
        width={width || sizeWidth}
        centered
        closeIcon={<CloseIcon />}
        okButtonProps={{ ...okButtonProps }}
        cancelButtonProps={{ ...cancelButtonProps }}
        maskClosable={false}
        {...props}
      >
        {type === "tip" && (
          <TipWrapper>
            <NormalTipIcon />
            {tipContent}
          </TipWrapper>
        )}
        {children}
        <ModalStyle />
      </AntdModal>
    </ConfigProvider>
  );
}

const confirm = ({ className, ...param }: ModalFuncProps) =>
  AntdModal.confirm({
    className: `renderbus-ui--modal ${className}`,
    ...param,
  });
Modal.confirm = confirm;
